export default "__VITE_ASSET__wbYO1j7L__"